/**
 * Routes configuration
 * Centralized route paths for consistent navigation throughout the app
 * 
 * Best practices:
 * - Use kebab-case for multi-word paths
 * - Use hierarchical RESTful structure (/resource/action)
 * - Keep paths lowercase
 */

export const ROUTES = {
  // Root
  HOME: '/',
  
  // Auth
  AUTH: '/auth',
  AUTH_CODE: '/auth/code',
  AUTH_SMS_VERIFY: '/auth/sms-verify',
  OAUTH_CALLBACK: '/auth/oauth/callback',
  
  // Profile
  PROFILE: '/profile',
  CONFIRM_CHANGE: '/confirm-change',
  
  // Surveys (doctor)
  SURVEYS: '/surveys',
  SURVEY_EDITOR: '/surveys/editor',
  
  // Surveys (patient)
  MY_SURVEYS: '/surveys/my',
  TAKE_SURVEY: '/surveys/take',
  SURVEY_HISTORY: '/surveys/history',
  SURVEY_ATTEMPT_DETAIL: '/surveys/attempt',
  
  // Questions
  QUESTIONS: '/questions',
  QUESTION_EDITOR: '/questions/editor',
  
  // Patients
  PATIENTS: '/patients',
  PATIENT_SCHEDULED: '/patients/scheduled',

  // Patient Groups (doctor)
  PATIENT_GROUPS: '/patient-groups',
  PATIENT_GROUP_DETAIL: '/patient-groups/:groupId',

  // Patient Chat (doctor)
  PATIENT_CHAT: '/patients/chat',

  // Doctor notifications (patient assessment)
  NOTIFICATIONS: '/alerts',
  
  // Doctors
  DOCTORS: '/doctors',
  
  // Scheduler
  SCHEDULER: '/scheduler',
  
  // Medications
  PATIENT_MEDICATIONS: '/patients/medications',
  MY_MEDICATIONS: '/medications/my',
  MY_MEDICATION_CALENDAR: '/medications/calendar',
  MEDICATION_HISTORY: '/medications/history',
  
  // Static pages
  ABOUT: '/about',
  
  // 404
  NOT_FOUND: '*',
};

// Alias for backward compatibility during transition
export const RoutePaths = ROUTES;

export default ROUTES;
